import { h } from 'preact';
export const LogIn = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" }),
        h("polyline", { points: "10 17 15 12 10 7" }),
        h("line", { x1: "15", y1: "12", x2: "3", y2: "12" })));
};
//# sourceMappingURL=log-in.js.map